import type { ReactNode } from 'react';
import type { WorkspaceShellContentSlots, WorkspaceShellServices } from './workspaceShellTypes.js';
import { renderProfessionalWorkspaceShell } from './ProfessionalWorkspaceShell.js';

export function renderMissionControlWorkspaceShell(slots: WorkspaceShellContentSlots, services: WorkspaceShellServices): ReactNode {
  return (
    <div data-testid="mission-control-shell-reserved" data-shell-status="reserved" style={{ display: 'contents' }}>
      {renderProfessionalWorkspaceShell(slots, services)}
    </div>
  );
}
